"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var getReferenceIdentifierFieldDefinitions = function (receiverRequirements) {
    return receiverRequirements ? receiverRequirements.fieldDefinitions.filter(function (fieldRequirement) { return fieldRequirement.key.startsWith("referenceIdentifier"); }) : [];
};
exports.getReferenceIdentifierFieldDefinitions = getReferenceIdentifierFieldDefinitions;
var getReferenceIdentifierOptions = function (receiverRequirements) {
    var referenceIdentifierFieldDefinitions = getReferenceIdentifierFieldDefinitions(receiverRequirements);
    return referenceIdentifierFieldDefinitions.map(function (fieldDefinition) {
        var delimiterIndex = fieldDefinition.key.indexOf(".");
        return __assign({}, fieldDefinition, { key: fieldDefinition.key.substring(delimiterIndex + 1), originalKey: fieldDefinition.key });
    });
};
exports.getReferenceIdentifierOptions = getReferenceIdentifierOptions;
